import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { RemoveFreeMemberRequest } from '../domain/dtos/free-member'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class RemoveFreeMember {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: RemoveFreeMemberRequest): Promise<void> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.FUNCTIONS_URL}/groupWhitelist/remove/pt`,
      body: { data: input },
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return
    }

    throw new GeneralError()
  }
}
